export default __webpack_public_path__ + "static/media/top-header-bg.b9cd43d3.jpg";